export default __webpack_public_path__ + "static/media/package.9f508feb.svg";